// פונקציה לקבלת כתובת השרת (תמיד http)
export const getServerUrl = () => {
  // בפיתוח - שימוש ב-proxy של Vite (נתיבים יחסיים)
  if (import.meta.env.DEV || !import.meta.env.PROD) {
    return ''; // נתיבים יחסיים דרך proxy
  }
  // בפרודקשן - נתיבים יחסיים (דרך .htaccess proxy)
  return '';
};

// פונקציה להמרת נתיבי תמונות
export const getImageUrl = (imageUrl) => {
  console.log('🔄 getImageUrl called with:', imageUrl);
  
  const zeroPadFilename = (path) => {
    try {
      // פדינג לשמות כמו N1.jpg -> N01.jpg, B1.jpg -> B01.jpg, E1.jpg -> E01.jpg
      // חל רק בתוך /images/products/
      const m = path.match(/^(.*\/images\/products\/)([NBE])(\d{1,2})(\.jpg)$/i);
      if (m) {
        const prefixPath = m[1];
        const letter = m[2];
        const num = m[3];
        const ext = m[4];
        const padded = num.length === 1 ? `0${num}` : num;
        return `${prefixPath}${letter.toUpperCase()}${padded}${ext.toLowerCase()}`;
      }
    } catch {}
    return path;
  };

  if (!imageUrl) {
    const result = `${getServerUrl()}/images/placeholder.svg`;
    console.log('🔄 No imageUrl provided, returning placeholder:', result);
    return result;
  }
  
  // המרה אוטומטית של כל URL שמפנה ל-IP/localhost עם פורט לנתיב יחסי, כולל http ו-https
  // דוגמאות: http(s)://3.16.146.3:3000/images/... -> /images/...
  //          http(s)://localhost:5002/images/... -> /images/...
  try {
    const ipWithPortRegex = /^https?:\/\/(?:localhost|127\.0\.0\.1|\d{1,3}(?:\.\d{1,3}){3})(?::\d+)?(\/images\/.*)$/;
    const m = imageUrl.match(ipWithPortRegex);
    if (m && m[1]) {
      return zeroPadFilename(m[1]);
    }
  } catch {}
  
  // אם זה נתיב יחסי שכבר מתחיל ב-/images
  if (imageUrl.startsWith('/images/')) {
    const result = `${getServerUrl()}${zeroPadFilename(imageUrl)}`;
    console.log('🔄 Image starts with /images/, result:', result);
    return result;
  }
  
  // אם זה נתיב מלא שמכיל /images/products/
  if (imageUrl.includes('/images/products/')) {
    const relativePath = imageUrl.split('/images/')[1];
    const result = `${getServerUrl()}/images/${relativePath}`;
    return result;
  }
  
  // אם זה נתיב מלא שמכיל /images/
  if (imageUrl.includes('/images/')) {
    const relativePath = imageUrl.split('/images/')[1];
    const result = `${getServerUrl()}/images/${relativePath}`;
    return result;
  }

  // אם זה כבר URL מלא אחר (למשל Cloudinary), נשאיר אותו כמו שהוא
  if (imageUrl.startsWith('http')) {
    return imageUrl;
  }
  
  // אם זה נתיב יחסי אחר
  if (imageUrl.startsWith('/')) {
    const result = `${getServerUrl()}${zeroPadFilename(imageUrl)}`;
    return result;
  }
  
  // Fallback - נסה להוסיף prefix
  const result = `${getServerUrl()}/images/products/${imageUrl}`;
  return zeroPadFilename(result);
};

const isPlaceholderImage = (imageUrl) => {
  return typeof imageUrl === 'string' && imageUrl.toLowerCase().includes('placeholder');
};

const getSkuImagePath = (sku) => {
  if (!sku || typeof sku !== 'string') return null;

  const match = sku.match(/(?:^|-)SH?A?-?([NBE])[-_]?0*(\d+)/i) || sku.match(/([NBE])[-_]?0*(\d+)/i);
  if (!match) return null;

  const prefix = match[1].toUpperCase();
  const number = String(Number(match[2])).padStart(2, '0');
  return `/images/products/${prefix}${number}.jpg`;
};

// פונקציה לטיפול בתמונות מרובות
export const getMultipleImageUrls = (images) => {
  if (!images || !Array.isArray(images)) {
    return [`${getServerUrl()}/images/placeholder.svg`];
  }
  
  return images.map(img => getImageUrl(img)).filter(Boolean);
};

// פונקציה לטיפול בתמונות מוצר
export const getProductImages = (product) => {
  console.log('🔍 getProductImages called with product:', product);
  
  let images = [];
  
  // אם יש מערך images - נעדיף אותו (זה מה שמגיע מהמסד המעודכן)
  if (product?.images && Array.isArray(product.images) && product.images.length > 0) {
    console.log('📸 Using product.images array:', product.images);
    images = [...product.images];
  } else {
    console.log('📸 Using fallback image fields');
    // אם אין מערך images, נשתמש בשדות הישנים
    if (product?.imageUrl) images.push(product.imageUrl);
    if (product?.image2) images.push(product.image2);
    if (product?.image3) images.push(product.image3);
    if (product?.image4) images.push(product.image4);
    if (product?.image5) images.push(product.image5);
    console.log('📸 Fallback images collected:', images);
  }
  
  // הסרת כפילויות
  const uniqueImages = [...new Set(images.filter(Boolean))];
  console.log('📸 Unique images after filtering:', uniqueImages);

  const skuImagePath = getSkuImagePath(product?.sku);
  if (skuImagePath && (uniqueImages.length === 0 || uniqueImages.every(isPlaceholderImage))) {
    console.log('📸 Using SKU-based image fallback:', skuImagePath);
    uniqueImages.unshift(skuImagePath);
  }
  
  // אם אין תמונות, נשתמש בתמונה ברירת מחדל
  if (uniqueImages.length === 0) {
    console.log('📸 No images found, using placeholder');
    uniqueImages.push(`${getServerUrl()}/images/placeholder.svg`);
  }
  
  // המרת הנתיבים
  const processedImages = uniqueImages.map(img => {
    const processed = getImageUrl(img);
    console.log(`📸 Processing image: ${img} -> ${processed}`);
    return processed;
  }).filter(Boolean);
  
  console.log('📸 Final processed images:', processedImages);
  return processedImages;
}; 

// פונקציה לקבלת כתובת API
export const getApiUrl = (endpoint) => {
  return `${getServerUrl()}/api${endpoint}`;
}; 